import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Text,
} from "@chakra-ui/react";
import axios from "../../axiosConfig";
import { useTranslation } from "react-i18next";

const ReportItemLevelModal = ({ isOpen, onClose, organizationSurveyId, team, factor, factorId, context }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [questionStats, setQuestionStats] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;

    const fetchDetails = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/survey_reports/${organizationSurveyId}/item_level`,
          {
            params: { team, factor, factorId, context },
          }
        );
        setQuestionStats(response.data.questions || []);
        setError("");
      } catch (err) {
        setError(t("reports.itemLevel.loadError"));
        setQuestionStats([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [isOpen, organizationSurveyId, team, factor, factorId, context, t]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("reports.itemLevel.detailsTitle", { team, factor })}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <Spinner />
          ) : error ? (
            <Text color="red.500">{error}</Text>
          ) : (
            <Table size="sm" mt={2}>
              <Thead>
                <Tr>
                  <Th>{t("reports.itemLevel.question")}</Th>
                  <Th isNumeric>{t("reports.itemLevel.score")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {questionStats.map((item, index) => (
                  <Tr key={index}>
                    <Td>{item.question}</Td>
                    <Td isNumeric>{parseFloat(item.stability_index).toFixed(2)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReportItemLevelModal;